export const SETTINGS_STORAGE_KEYS = {
  CORE: "mt6_settings_core",
} as const;
